@if (breadcrumbs().length > 1) {
  <div class="breadcrumb">
    @for (breadcrumb of breadcrumbs(); track breadcrumb.url) {
      <div class="breadcrumb-item">
        <div class="arrow-left-for-mobile material-icons" aria-hidden="true">chevron_left</div>
        <a routerLink="{{ breadcrumb.url }}" [class.pointer-none]="$last" [tabindex]="$last ? -1 : 0">
          {{ breadcrumb.isStatic ? ('CORE.COMPONENTS.BREADCRUMB.' + breadcrumb.label | translate) : breadcrumb.label }}
        </a>
        <div class="arrow-right material-icons" aria-hidden="true">chevron_right</div>
      </div>
    }
  </div>
}
